import { getAxiosConfig } from 'fe-common'

export default {
  actions: {
    // webapi
    userSubscribe(context, payload) {
      return this.$axios.$post(
        `/webapi/user/subscribe`,
        payload,
        getAxiosConfig(context)
      )
    },
    userUnsubscribe(context, { endpoint }) {
      return this.$axios.$post(
        `/webapi/user/unsubscribe`,
        {
          endpoint
        },
        getAxiosConfig(context)
      )
    },

    // my server
    subscribe(context, payload) {
      return this.$axios.$post('/subscribe', payload, getAxiosConfig(context))
    },
    unsubscribe(context, { endpoint }) {
      return this.$axios.$delete(
        `/subscribe/${encodeURIComponent(endpoint)}`,
        getAxiosConfig(context)
      )
    }
  }
}
